<template>
  <div>
    <div class="w-full lg:w-1/2">
      <CommonTeacherReviewScores :items="numbers" hidden-stars />
    </div>
    <CommonTeacherReviewComments
      :list="comments"
      class="mt-4"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CommonTeacherReviewScores from '~/components/common/teacher-review/teacher-review-scores'
import CommonTeacherReviewComments from '~/components/common/teacher-review/teacher-review-comments'
export default {
  name: 'TeacherListReviewContent',
  components: { CommonTeacherReviewComments, CommonTeacherReviewScores },
  computed: {
    ...mapGetters('teacher', ['getFeedbacks']),
    comments () {
      return this.getFeedbacks.comments
    },
    numbers () {
      return this.getFeedbacks.numbers
    }
  }
}
</script>

<style scoped>

</style>
